import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { MediaBreakpointsProvider, MEDIA_BREAKPOINTS_PROVIDER } from './media-breakpoints.provider';

export function provideMediaObserver(breakpoints: MediaBreakpointsProvider): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: MEDIA_BREAKPOINTS_PROVIDER,
      useValue: breakpoints,
    },
  ]);
}
